"use strict";
/* globals module */
/**
 * @module notificationsRegistrationsAnonymousBatchRoute
 * @description Baasic Notifications Registrations Anonymous Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Anonymous Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var NotificationsRegistrationsAnonymousBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsAnonymousBatchRoute, _super);
    function NotificationsRegistrationsAnonymousBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/registrations/anonymous/batch';
        _this.deleteRoute = 'notifications/registrations/anonymous/batch';
        return _this;
    }
    /**
     * Parses create anonymous registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousBatchRoute.create();
     */
    NotificationsRegistrationsAnonymousBatchRoute.prototype.create = function () {
        return this.baseCreate(this.createRoute, {});
    };
    /**
     * Parses delete anonymous registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousBatchRoute.delete();
     */
    NotificationsRegistrationsAnonymousBatchRoute.prototype.delete = function () {
        return this.baseDelete(this.deleteRoute, {});
    };
    /**
     * Parses update anonymous registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousBatchRoute.update();
     */
    NotificationsRegistrationsAnonymousBatchRoute.prototype.update = function () {
        return this.baseUpdate('notifications/registrations/anonymous/batch', {});
    };
    var _a;
    NotificationsRegistrationsAnonymousBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsRegistrationsAnonymousBatchRoute);
    return NotificationsRegistrationsAnonymousBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsAnonymousBatchRoute = NotificationsRegistrationsAnonymousBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
